import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Login from "components/Auth/Login";
import { SignIn } from 'store/actions/authActions'

export default function LoginPage() {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [showNotification, setShowNotification] = useState({ type: "", message: "" });
  const [isSubmitting, setIsSubmitting] = useState(false)

  const onComplete = (val, showError) => {
    !val && setIsSubmitting(false)
    if (showError) {
      setShowNotification({ type: "error", message: showError });
    }
  }



  async function handleSubmit(data) {
    setIsSubmitting(true)
    setShowNotification(false);

    SignIn(
      {
        email: data.email.toLowerCase(),
        password: data.password,
      },
      onComplete,
      dispatch,
      navigate,
    )
  }

  async function handleForgot() {
    navigate("/auth/forgot-password");
  }

  function handleAlertClose() {
    setShowNotification({ type: "", message: "" });
  }

  return (
    <>
      <Login
        isSubmitting={isSubmitting}
        onSubmit={handleSubmit}
        onForgot={handleForgot}
        onSignup={() => { }}
        onAlertClose={handleAlertClose}
        showNotification={showNotification}
      />
    </>
  );
}
